<script lang="ts" setup>
  import { useLocale } from '@tundr/i18n';
  import { type MaybeRef, computed, isRef } from 'vue';

  export type StepIndicatorProps = {
    currentStep: MaybeRef<number>;
    totalSteps: MaybeRef<number>;
    tooltip?: string;
  };

  const props = defineProps<StepIndicatorProps>();

  const currentStepValue = computed(() => {
    if (isRef(props.currentStep)) {
      return props.currentStep.value;
    } else {
      return props.currentStep;
    }
  });
  const totalStepsValue = computed(() => {
    if (isRef(props.totalSteps)) {
      return props.totalSteps.value;
    } else {
      return props.totalSteps;
    }
  });

  const { t } = useLocale('stepper');
</script>

<template>
  <div>
    <strong>{{ t('step', { currentStep: currentStepValue + 1 }) }}</strong>
    {{ t('of', { totalSteps: totalStepsValue }) }}
  </div>
</template>
